import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FAQS = [
  ["Do creators pay anything upfront?", "No. There are no upfront fees for creators. WPA earns a percentage only once a brand deal is reached."],
  ["When does the percentage apply?", "Only after a deal has been agreed between a creator and a brand through WPA. If there's no deal, there's nothing to pay."],
  ["How are fees for brands decided?", "Brand fees are determined after you share your campaign scope, and are discussed once an agreement has been reached."],
  ["How do I get started?", "Creators can send an application through our website. Brands can use the \"Find Creators for your Brand\" form and we'll be in touch."],
];

export const FeeFAQ = () => (
  <section id="fees" className="relative bg-white">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <p className="text-[12px] font-bold tracking-[0.2em] uppercase text-pink mb-6">Fees</p>
        <h2 className="font-display text-ink leading-[1]" style={{ fontSize: "clamp(40px, 6vw, 84px)" }}>
          How our fees <span className="text-pink">work.</span>
        </h2>
        <p className="mt-6 text-ink/70 text-[17px] leading-relaxed max-w-[44ch]">
          Clear and simple: creators pay nothing upfront, and brand fees are agreed once we understand your campaign.
        </p>
      </div>
      <Accordion type="single" collapsible defaultValue="q0" className="lg:col-span-7 flex flex-col gap-4" data-testid="fee-faq">
        {FAQS.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="bg-cream rounded-[24px] border-2 border-ink px-6">
            <AccordionTrigger className="font-display text-ink text-[18px] sm:text-[22px] text-left hover:no-underline" data-testid={`fee-faq-q${i}`}>
              {q}
            </AccordionTrigger>
            <AccordionContent className="text-ink/75 text-[16px] leading-relaxed" data-testid={`fee-faq-a${i}`}>
              {a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
